<template>
  <div>
    <div class="grid-content maintitle">
      <span>事件接口白名单</span>
    </div>

    <div class="grid-content content-margin topFix" >
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button size="medium" round @click="createTarget">
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.新增") }}
          </el-button>
        </el-link>
      </div>
    </div>

    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
      >
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-edit"
                @click="editTarget(scope.row)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  deleteRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>

        <el-table-column prop="id" label="序号" width="175" fixed>
        </el-table-column>
        <el-table-column prop="appid" label="AppID" width="175" fixed>
        </el-table-column>
        <el-table-column prop="interfacepath" label="接口路径" width="300">
        </el-table-column>
        <el-table-column prop="limitcount" label="限制次数" width="300">
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>事件接口白名单</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false">
            <el-button size="medium" round @click="doSaveDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <!-- AppID -->
          <tr>
            <td>
              <span class="simpleLabel">AppID</span>
            </td>
            <td>
              <el-input
                v-model="editData.appid"
                placeholder="请输入内容"
                size="small"
                disabled
              >
              </el-input>
            </td>
          </tr>

          <!-- interfacePath -->
          <tr>
            <td>
              <span class="simpleLabel">接口路径</span>
            </td>
            <td>
              <el-input
                v-model="editData.interfacepath"
                placeholder="请输入内容"
                size="small"
                clearable
              ></el-input>
            </td>
          </tr>

          <!-- limitCount -->
          <tr>
            <td>
              <span class="simpleLabel">限制次数</span>
            </td>
            <td>
              <el-input
                v-model="editData.limitcount"
                placeholder="请输入内容"
                size="small"
                clearable
              ></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
export default {
  name: "EventInterfaceWhiteList",
  data() {
    return {
      hasAuth: false,
      isEditMode: false,
      deleteDialogVisible: false,
      showDateilDrawer: false,
      tableHeight: 500,
      tableData: [],
      editData: {
        appid: 188,
        interfacepath: String,
        limitcount: Number
      },
      deleteRow: {},
      typeOptions: [],
    };
  },
  watch: {},
  methods: {
    deleteTarget() {
      this.deleteDialogVisible = false;
      rejecthttp(
        true,
        "post",
        "/manage/eventinterface/delwhitelist",
        {
          appid: this.deleteRow.appid,
          id: this.deleteRow.id
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.refresh();
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    doSaveDetail() {
      //编辑
      if (this.isEditMode == true) {
        this.onUpdate();
      }
      //添加
      else {
        this.onAdd();
      }

      this.resetEditData();

      this.isEditMode = false;
      this.showDateilDrawer = false;
    },

    resetEditData() {
      this.editData.appid = 188;
      this.editData.interfacepath = null;
      this.editData.limitcount = null;
    },

    onAdd() {
      rejecthttp(
        true,
        "post",
        "/manage/eventinterface/addwhitelist",
        this.editData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.refresh();
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    onUpdate() {
      rejecthttp(
        true,
        "post",
        "/manage/eventinterface/updatewhitelist",
        this.editData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.refresh();
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    editTarget(row) {
      // this.editData.type = row.type;
      // this.editData.apiappid = row.apiappid;
      // this.editData.apisecret = row.apisecret;
      // this.editData.authcode = row.authcode;
      // this.editData.authorizerrefreshtoken = row.authorizerrefreshtoken;
      // this.url = row.url;
      // this.param1 = row.param1;
      // this.param2 = row.param2;
      this.editData = JSON.parse(JSON.stringify(row));
      console.log(this.editData);

      this.showDateilDrawer = true;
      this.isEditMode = true;
    },

    createTarget() {
      this.resetEditData();
      this.editData.appid = 188;
      this.isEditMode = false;
      this.showDateilDrawer = true;
    },

    copyInfo(info) {
      const el = document.createElement("textarea");
      el.value = info;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    getTypeName(type) {
      for (var i = 0; i < this.typeOptions.length; ++i) {
        if (type == this.typeOptions[i].value) {
          return this.typeOptions[i].label;
        }
      }
    },

    getAppSecret(AppSecret) {
      if (this.hasAuth == false) {
        return AppSecret;
      }

      if (AppSecret == null) {
        return "";
      }

      var star = "";

      var e = AppSecret.length / 2; //屏蔽树
      var h = AppSecret.length / 4; //头部
      var s = AppSecret.length - e - h; //尾部
      for (var i = 0; i < e; i++) {
        star += "*";
      }
      var res = AppSecret.substring(0, h) + star;
      if (s > 0)
        res += AppSecret.substring(AppSecret.length - s, AppSecret.length);
      return res;
    },

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/eventinterface/getwhitelist",
        {
          appid: 188,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.tableData = doc.data.data;
            console.log(this.tableData);
            this.changeTableHeight();
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },

    changeTableHeight() {
      this.$nextTick(function () {
        if (this.$refs.table.$el !== "undefined")
          this.tableHeight =
            window.innerHeight - this.$refs.table.$el.offsetTop - 160;
        console.log(this.tableHeight);

        // 监听窗口大小变化
        let self = this;
        window.onresize = function () {
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 160;
        };
      });
    },
  },
  mounted: function () {
    this.changeTableHeight();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  created() {
    this.refresh();
    this.resetEditData();
  },
  components: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/EventInterfaceWhiteList.vue